<template>
	<div class="create-task-container pb-4" @click="close_selection += 1">
		<div v-if="isEdit" class="top-line"></div>
		<div v-if="isEdit" class="pt-3 px-6 task-title">
			<div v-if="isEdit" class="title-text">Public Holiday</div>
			<div class="task-title">
				<Delete v-if="isEdit && modifyPubHolPrivilege" class="mt-1 step-item-text-hover" style="height: 20px; width: 20px" :color="`rgba(25, 42, 62, 0.7)`" @click="onDeleteEvent()"/>
				<v-icon @click.stop="onEditEventClose()">mdi-close</v-icon>
			</div>
		</div>
		<v-alert class="mx-3 mt-3" type="error" v-if="error_msg.length !== 0">
			{{ error_msg }}
		</v-alert>
		<v-progress-linear v-if="loading" class="px-3 mt-3" indeterminate color="rgba(0, 0, 0, 0.12)" height="12"></v-progress-linear>
		<template v-if="!loading">
			<v-row class="mt-6 mb-0 mx-0 px-6">
				<v-text-field
					v-model="event_name"
					:color="isEdit ? edit_color : color"
					:error="error_name_flag"
					:disabled="isEdit && !abledEdit"
					background-color="#FAFAFA"
					placeholder="Enter Public holiday name here"
					autofocus
					outlined
					dense
					hide-details
					min-width="auto"
					@change="onNameChange()"
				>
				</v-text-field>
			</v-row>
			<v-row class="ma-0 px-6">
				<v-col :class="!isEdit && event_type_items.length > 1 ? 'py-0 px-0':'pt-0 px-0'" :cols="$vuetify.breakpoint.xsOnly ? 12 : 7">
					<v-row v-if="!isEdit && event_type_items.length > 1" class="mb-1 mx-0" :class="$vuetify.breakpoint.xsOnly ? 'mt-6':'mt-9'">
						<v-select
							class="type"
							v-model="event_type_select"
							:items="event_type_items"
							:menu-props="{ bottom: true, offsetY: true}"
							background-color="#FAFAFA"
							item-text="desc"
							item-value="id"
							:item-color="isEdit ? edit_color : color"
							:error="error_type_flag"
							:color="isEdit ? edit_color : color"
							:disabled="isEdit"
							placeholder="Select Public holiday type..."
							outlined
							flat
							dense
							hide-details
							return-object
							@change="onSelected($event)"
						>
						</v-select>
					</v-row>
					<v-progress-linear v-if="type_loading" class="mx-2" indeterminate color="rgba(0, 0, 0, 0.12)" height="12"></v-progress-linear>
					<v-row v-if="event_wholeday && !type_loading" :class="$vuetify.breakpoint.xsOnly ? 'mx-0 mt-1 mb-1':'ma-0'">
						<v-col class="px-0 pb-0">
							<span :class="isEdit && !abledEdit ? 'item-text-disable':'item-text'">Start date to End date</span>
							<DateMulti
								:suggestionText="`eg, 120322-130322 or 12/3/2022-13/3/2022`"
								:color="isEdit ? edit_color : color"
								:background="`#FAFAFA`"
								:error="error_start_date_flag || error_end_date_flag"
								:disabled="isEdit && !abledEdit"
								:dateStartInit="start_date"
								:dateEndInit="end_date"
								@dateRange="onDateRangeChange($event)"
							/>
						</v-col>
					</v-row>
					<v-row v-if="!event_wholeday && !type_loading" class="ma-0 pb-1 pt-3">
						<v-col class="py-0" :cols="$vuetify.breakpoint.xsOnly ? 12 : 6" :class="$vuetify.breakpoint.xsOnly ? 'px-0' :'pl-0 pr-2'">
							<span :class="isEdit && !abledEdit ? 'item-text-disable':'item-text'">Date</span>
							<DatePicker
								:isOutlined="true"
								:isIcon="true"
								:color="isEdit ? edit_color : color"
								:suggestionText="`eg, 120322 or 12/3/2022`"
								:error="error_date_flag"
								:disabled="isEdit && !abledEdit"
								:dateInit="start_date"
								@date="onDateChange($event)"
							/>
						</v-col>
						<v-col :cols="$vuetify.breakpoint.xsOnly ? 12 : 6" class="px-0 pt-1">
							<DateTime
								:color="isEdit ? edit_color : color"
								:duration="`${event_duration}m`"
								:startTimeInit="time_start_init"
								:endTimeInit="time_end_init"
								:startError="start_time_error"
								:errorStartFlag="error_start_time_flag"
								:endError="end_time_error"
								:errorEndFlag="error_end_time_flag"
								:disabled="isEdit && !abledEdit"
								:styleLeft="`px-0 py-0`"
								:styleRight="`pl-2 pr-0 py-0`"
								@time_start="onTimeStartChange($event)"
								@time_end="onTimeEndChange($event)"
							/>
						</v-col>
					</v-row>
					<v-row class="mt-0 mb-0 mx-0">
						<v-col class="px-0 pt-0" cols="12">
							<span :class="isEdit && !abledEdit? 'item-text-disable':'item-text'">Time zone</span>
							<v-autocomplete
								v-model="timezone"
								:items="timezone_items"
								:color="color"
								:menu-props="{ bottom: true, offsetY: true}"
								:loading="timezone_loading"
								:disabled="isEdit && !abledEdit"
								background-color="#FAFAFA"
								item-text="name"
								item-value="key"
								item-color="success"
								outlined
								dense
								hide-details
								return-object
								clearable
								@change="onTimezoneChange()"
							>
								<template v-slot:item="{item, on}">
									<v-list-item style="min-height: 32px">
										<v-row v-if="item.children !== 0" class="mt-2 mb-0">
											<v-col cols="12" class="py-0">
												<div class="step-item-text" style="font-weight: 500; color: rgba(25, 42, 62, 0.5)">{{ item.name }}</div>
											</v-col>
											<v-col cols="12" class="pt-1 pb-0">
												<v-divider></v-divider>
											</v-col>
										</v-row>
										<div v-if="item.children === 0" class="step-item-text step-item-text-hover" style="color: rgba(25, 42, 62, 1)" v-on="on">{{ item.name }}</div> 
									</v-list-item>
								</template>
							</v-autocomplete>
						</v-col>
					</v-row>
					<v-row v-if="links === mandatory_job" class="ma-0">
						<v-col class="px-0 py-0" cols="12">
							<span :class="isEdit && !abledEdit ? 'item-text-disable':'item-text'">Job</span>
							<v-autocomplete
								v-model="job_select"
								:items="job_items"
								:loading="job_loading"
								:search-input.sync="job_search"
								:color="isEdit ? edit_color : color"
								:error="error_job_flag || (links === mandatory_job && !job_select)"
								:disabled="isEdit && !abledEdit"
								prepend-inner-icon="mdi-magnify"
								append-icon=""
								background-color="#FAFAFA"
								item-text="display_name"
								item-value="id"
								item-color="success"
								item-disabled="disabled"
								placeholder="Type to search job names or numbers"
								auto-select-first
								outlined
								dense
								hide-no-data
								return-object
								hide-details
								clearable
								@change="onJobSelected($event)"
							>
							</v-autocomplete>
						</v-col>
					</v-row>
					<v-row v-if="links !== no_related" class="ma-0">
						<v-col :class="links === optional ? 'px-0 pb-0':'px-0'" cols="12">
							<span :class="isEdit && !abledEdit ? 'item-text-disable':'item-text'">Address Book</span>
							<v-autocomplete
								v-model="address_select"
								:items="address_items"
								:loading="address_loading"
								:search-input.sync="address_search"
								:color="isEdit ? edit_color : color"
								:error="error_addressbook_flag || ((links === mandatory || links === mandatory_job) && !address_select)"
								:disabled="isEdit && !abledEdit"
								prepend-inner-icon="mdi-magnify"
								append-icon=""
								background-color="#FAFAFA"
								item-text="display_name"
								item-value="id"
								item-color="success"
								item-disabled="disabled"
								placeholder="Type to search company or contact names"
								auto-select-first
								outlined
								dense
								hide-no-data
								return-object
								hide-details
								clearable
								@change="onAddressSelected($event)"
							>
								<template v-slot:selection="data">
									<v-chip
										v-bind="data.attrs"
										:input-value="data.selected"
										:disabled="isEdit && !abledEdit"
										close
										label
										@click:close="onRemoveAddress()"
									>
										{{ data.item.display_name }}
									</v-chip>
								</template>
							</v-autocomplete>
							<div v-if="links === optional" class="optional-text">optional</div>
						</v-col>
					</v-row>
					<v-row v-if="is_contact_needed && is_business" class="ma-0">
						<v-col class="pa-0" cols="12">
							<span :class="isEdit && !abledEdit ? 'item-text-disable':'item-text'">Contact</span>
							<v-autocomplete
								v-model="contact_select"
								:items="contact_items"
								:loading="contact_loading"
								:search-input.sync="contact_search"
								:color="color"
								:disabled="isEdit && !abledEdit"
								prepend-inner-icon="mdi-magnify"
								append-icon=""
								background-color="#FAFAFA"
								item-text="display_name"
								item-value="id"
								item-color="success"
								item-disabled="disabled"
								placeholder="Type to search contact names"
								no-data-text=""
								auto-select-first
								outlined
								dense
								return-object
								hide-details
								clearable
								@change="onContactSelected($event)"
							>
							</v-autocomplete>
							<div class="optional-text" style="float: right; line-height: 12px; margin-top: 4px;">optional</div>
						</v-col>
					</v-row>
					<v-row v-if="!description_loading" class="ma-0">
						<v-col class="px-0 pb-0" cols="12">
							<span :class="isEdit && !abledEdit ? 'item-text-disable':'item-text'">Event Description</span>
							<RichText v-model="content" :toolbar="toolbar" :plugins="plugins" :height="250" :disabled="isEdit && !abledEdit" />
						</v-col>
					</v-row>
				</v-col>
				<v-col :class="[!isEdit && event_type_items.length > 1 ? 'py-0 pr-0':'pt-0 pr-0', $vuetify.breakpoint.xsOnly ? 'px-0':'']" :cols="$vuetify.breakpoint.xsOnly ? 12 : 5">
					<v-row class="mt-4 mx-0 mb-0" style="height: 100%">
						<v-divider v-if="!$vuetify.breakpoint.xsOnly" vertical color="#D9D9D9"/>
						<div class="column-container" style="width: 100%">
							<div v-if="can_invitemultiple" :class="[$vuetify.breakpoint.xsOnly ? '':'px-2', isEdit && !abledEdit ? 'item-text-disable':'item-text']">Invitees</div>
							<div v-if="can_invitemultiple" class="column-container" :class="!$vuetify.breakpoint.xsOnly ? 'pl-2':''">
								<InviteesTreeSelection
									:color="color"
									:bgColor="'#FAFAFA'"
									:selected="select_invitees"
									:address="address_select"
									:closeSelection="close_selection"
									@assign-selected="onInviteeSelected($event)"
								/>
							</div>
							<div v-if="can_invitemultiple" class="item-text ml-2 mt-3">Select invitees below to email:</div>
							<div v-if="can_invitemultiple" class="ml-2 mb-2">
								<v-checkbox
									v-model="email"
									:color="isEdit ? edit_color : color"
									dense
									hide-details
									:disabled="!can_invitemultiple || (isEdit && !abledEdit)"
									@change="onSelectAllEmailChange()">
									<template v-slot:label>
										<span class="item-text" :style="!can_invitemultiple? 'opacity: 0.5':''">Select all</span>
									</template>
								</v-checkbox>
							</div>
							<div style="height: 338px">
								<v-virtual-scroll
									:items="inviteesFilter"
									:height="$vuetify.breakpoint.xsOnly ? 100:330"
									item-height="48"
								>
									<template v-slot:default="{ item }">
										<div class="task-title pl-2">
											<div>
												<v-checkbox
													class="mt-0 pt-0"
													v-model="item.employee.send_email"
													:color="isEdit ? edit_color : color"
													:disabled="isEdit && !abledEdit"
													dense
													hide-details
													@change="onEmailChange()">
													<template v-slot:label>
														<div class="task-top over-background" style="justify-content: flex-start">
															<div class="mr-1">
																<v-user-avatar
																	size="24"
																	class="text-caption text-decoration-none"
																	:code="formatName(item.employee.display_name)"
																	:image="`/api/addressbook/${item.employee.id}/image.png`"
																/>
															</div>
															<div class="column-container">
																<div class="item-text over-text" style="color: #192A3E">{{ formatName(item.employee.display_name) }}</div>
																<div v-if="item.employee.email.length !== 0" class="item-text over-text" style="color: rgba(25, 42, 62, 0.7); font-size: 12px; width: 148px;">{{ item.employee.email }}</div>
															</div>
														</div>
													</template>
												</v-checkbox>
											</div>
											<div>
												<v-btn icon color="rgba(25, 42, 62, 0.5)" :disabled="isEdit && !abledEdit" @click.stop="onRemoveInvitee(item.id)">
													<v-icon>mdi-close</v-icon>
												</v-btn>
											</div>
										</div>
									</template>
								</v-virtual-scroll>
							</div>
						</div>
					</v-row>
				</v-col>
			</v-row>
			<v-row class="ma-0 pl-5 pr-9" justify="space-between">
				<v-checkbox
					v-model="mark_approved"
					label="Approved"
					color="info"
					:disabled="isEdit ? !abledEdit: !approveLeaveEventsPrivilege"
					dense
					hide-details
					@change="onMarkCompleteChange()">
				</v-checkbox>
				<v-row :class="$vuetify.breakpoint.xsOnly ? 'mt-3 mb-0 mx-0':'ma-0'"  justify="end">
					<v-btn class="text-capitalize mr-2" outlined color="#82899B" @click="$emit('close')">Cancel</v-btn>
					<v-btn class="text-capitalize white--text" elevation="0" color="#00AAFD" :disabled="!isActive" @click="onSave()">
						<span v-if="isEdit">Save</span>
						<span v-else>Create</span>
					</v-btn>
				</v-row>
			</v-row>
		</template>
		<DialogNotice
			v-if="visible_notice" 
			:visible="visible_notice"
			:text="notice_text"
		/>
		<DeleteConfirmDialog 
			v-if="delete_visible"
			:visible="delete_visible" 
			:color="'error'"
			:title="`You are about to delete this holiday.`" 
			:content="`This action cannot be undone. Are you sure?`"
			:ok="'Yes, delete'"
			:icon_name_title="'mdi-alert-circle'"
			:icon_name_front="'mdi-delete-outline'"
			:maxWidth="500"
			@cancel="delete_visible = false"
			@ok="onDelete($event)"
		/>
	</div>
</template>

<script>
import InviteesTreeSelection from "@/views/events/invitees_tree_selection.vue"
import DateMulti from "@/components/date/date_multi.vue";
import DatePicker from "@/components/date/date_picker.vue";
import DateTime from "@/components/date/date_time.vue";
import DialogNotice from "@/components/dialogs/notice_dialog.vue";
import RichText from '@/views/rtf/RichText';
import DeleteConfirmDialog from "@/components/dialogs/delete_comfirm_dialog.vue";
import Delete from '@/components/icons/delete_outline';

import { validTime } from "@/common/validTime.js";

import config from "@/config.js";
import moment from 'moment-timezone';

/** 0-invited, 1-accepted, 2-rejected */
const Invited_Code = 0;
const Accepted_Code = 1;
const Rejected_Code = 2;

const ALLEMPLOYEES = 2;
const CLIENT = 3;
const FREELANCER = 4;

/** 0-tentative, 1-busy, 2 - leave */
const Plan_Type_Leave = 2;

/** 3 - public holiday */
const Leave_Type = 3;

const DescriptionLimit = 60;
const Edit_Color = '#FFB946';

/** if event_duration = 0, will set defaul duration(30mins) */
const Event_Duration_Default = 30;

const JOr = 'JOr';

/** If selected the user can manage public holidays */
const DPubHol = 'DPubHol';

/** If selected the user can manage and approve leave events */
const DAppLeave = 'DAppLeave';

/** If selected the user can delete approved leave events if not already in a payslip */
const DDelAppLeave = 'DDelAppLeave';


/**
 * 0=Other
 * 1=client
 * 2=Suppliers
 * 3=Employees
 * 6=Banks
 * 7=(Non)-performing artists
 * 8=Talent agencies
 * 9=Credit card suppliers
 * 10=Superannuation suppliers
 * 12=Freelancers
 * 14=Prospect
 * 15=Self billing talent
 * 16=Contacts
 * 17=Media suppliers
 * 18=Freelancer agencies
 */
const Address_Types = [0,1,2,3,6,7,8,9,10,12,14,15,16,17,18];

/** 
 *  0 - not display job and adddress
 *  1 - display job and adddress, but no required
 *  2 - display adddress, required
 *  3 - display job and adddress, required
 */
const No_Related = 0;
const Optional = 1;
const Mandatory = 2;
const Mandatory_Job = 3;

const Plugins = 'advlist lists table image link';
const Toolbar = ['bold italic underline strikethrough backcolor forecolor | indent outdent', 'align numlist bullist | link image inserttable'];

export default {
	name: 'NewHoliday',
	props: {
		color: {
			type: String,
			default: ''
		},
		isEdit: {
			type: Boolean,
			default: false
		},
		editEventItem: {
			type: Object,
			default: null,
		},
		startTime: {
			type: String,
			default: ''
		}
	},
	data() {
		this.toolbar = Toolbar;
		this.plugins = Plugins;

		this.no_related = No_Related;
		this.optional = Optional;
		this.mandatory = Mandatory;
		this.mandatory_job = Mandatory_Job;

		this.invited_code = Invited_Code;
		this.accepted_code = Accepted_Code;
		this.rejected_code = Rejected_Code;

		this.edit_color = Edit_Color;

		return {
			loading: false,
			type_loading: false,
			job_loading: false,
			address_loading: false,
			contact_loading: false,
			invitees_loading: false,
			timezone_loading: false,
			description_loading: false,

			error_msg: '',
			close_selection: 0,

			event_name: '',
			event_type_select: null,
			event_type_items: [],
			event_wholeday: true,
			event_duration: 0,
      
			start_date: '',
			end_date: '',
			event_start_date: null,
			event_end_date: null,
			origin_event_start_date: null,
			origin_event_end_date: null,

			event_date: null,
			event_start_time: null,
			event_end_time: null,
			time_start_init: '',
			time_end_init: '',
			origin_event_date: null,
			origin_event_start_time: null,
			origin_event_end_time: null,

			timezone_items: [],
			timezone: null,
			user_timezone: '',
			
			links: 0,
			is_contact_needed: false,
			job_select: null,
			job_items: [],
			job_search: null,
			job_invalid_status_ids: [],

			address_select: null,
			address_items: [],
			address_search: null,
			is_business: true,

			contact_select: null,
			contact_items: [],
			contact_search: null,

			content: '',
			mark_approved: false,

			can_invitemultiple: true,
			email: this.isEdit ? false : true,
			select_invitees: [],
			invitees_items: [],
			invitees_search: null,
			select_invitees_items: [],
			existed_invitees: [],
			
			error_name_flag: false,
			error_type_flag: false,
			error_start_date_flag: false,
			error_end_date_flag: false,
			error_date_flag: false,
			error_start_time_flag: false,
			error_end_time_flag: false,
			error_job_flag: false,
			error_addressbook_flag: false,
			button_click_flag: false,

			start_time_error: false,
			end_time_error: false,

			visible_notice: false,
			notice_text: [],
			tid: null,

			delete_visible: false,
		}
	},
	components: {
		InviteesTreeSelection,
		DateMulti,
		DatePicker,
		DateTime,
		RichText,
		DialogNotice,
		Delete,
		DeleteConfirmDialog
	},
	beforeDestroy() {
		if(this.tid) {
			clearTimeout(this.tid);
		}
	},
	async created() {
		this.description_loading = true;
		this.loading = this.isEdit;

		await this.getTimezone();
		await this.getUserTimezone();
		await this.getEventTypes();
		this.tid = setTimeout(this.initDescription(), 1000);

		if (!this.isEdit) {
			await this.getCurrentUser();
		}
		
		if (this.isEdit) {
			await this.getEvent(this.editEventItem);
		}

		if (this.startTime.length !== 0) {
			this.event_wholeday = false;
			this.event_duration = Event_Duration_Default;

			this.start_date = moment(this.startTime, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD');
			this.end_date = moment(this.startTime, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD');

			this.event_start_date = this.start_date;
			this.event_end_date = this.end_date;

			this.event_date = moment(this.startTime, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD');

			this.event_start_time = moment(this.startTime, 'YYYY-MM-DD HH:mm').format('h:mm a');
			this.event_end_time = moment(this.startTime, 'YYYY-MM-DD HH:mm').add(Event_Duration_Default, 'm').format('h:mm a');

			this.time_start_init = this.event_start_time ? this.event_start_time : '';
			this.time_end_init = this.event_end_time ? this.event_end_time : '';
		}
	},
	computed: {
		userId() {
			let user_id = null;
			
			if (this.$store.state.user) {
				user_id = this.$store.state.user.id;
			}		

			return user_id;
		},
		userAddressBook() {
			let user_tmp = null;
			
			if (this.$store.state.user && this.$store.state.user.addressbook) {
				user_tmp = this.$store.state.user.addressbook;
			}		

			return user_tmp;
		},
		isActive() {
			let active_tmp = false;

			if (this.event_name.length !== 0 && this.event_type_select) {
				let valid_date = false;

				if (this.event_wholeday) {
					valid_date = this.event_start_date && this.event_end_date && this.event_start_date <= this.event_end_date;
				} else {
					const time1 = moment(this.event_start_time, 'HH:mm a');
					const time2 = moment(this.event_end_time, 'HH:mm a');
					valid_date = this.event_date && this.event_start_time && this.event_end_time && (time2.diff(time1, 'minutes') >= 0);
				}

				const job_valid = this.links === Mandatory_Job ? this.job_select : true;
				const address_valid = this.links === Mandatory_Job || this.links === Mandatory ? this.address_select : true;

				let is_able = true;

				if (this.isEdit) {
					if (this.editEventItem.pay_processed) {
						is_able = false;
					} else if (this.editEventItem.leave_approved) {
						if (!this.modifyPubHolPrivilege || !this.approveLeaveEventsPrivilege) {
							is_able = false;
						}
					} else {
						if (!this.modifyPubHolPrivilege) {
							is_able = false;
						}
					}
				}

				if (valid_date && job_valid && address_valid && is_able) {
					active_tmp = true;
				}
			}

			return active_tmp;
		},
		completedJobPrivilege() {
			let isCompletedJobTmp = false;
			if (this.$store.state.privileges && this.$store.state.privileges.length !== 0 && this.$store.state.privileges.includes(JOr)) {
				isCompletedJobTmp = true;
			}
			return isCompletedJobTmp
		},
		approveLeaveEventsPrivilege() {
			let isApproveLeaveEvents = false;
			if (this.$store.state.privileges && this.$store.state.privileges.length !== 0 && this.$store.state.privileges.includes(DAppLeave)) {
				isApproveLeaveEvents = true;
			}
			return isApproveLeaveEvents;
		},
		modifyPubHolPrivilege() {
			let isModifyPubHolPrivilege = false;
			if (this.$store.state.privileges && this.$store.state.privileges.length !== 0 && this.$store.state.privileges.includes(DPubHol)) {
				isModifyPubHolPrivilege = true;
			}
			return isModifyPubHolPrivilege;
		},
		deleteApprovedLeavePrivilege() {
			let isDeleteApprovedLeavePrivilege = false;
			if (this.$store.state.privileges && this.$store.state.privileges.length !== 0 && this.$store.state.privileges.includes(DDelAppLeave)) {
				isDeleteApprovedLeavePrivilege = true;
			}
			return isDeleteApprovedLeavePrivilege;
		},
		inviteesFilter() {
			let invitees_list = [];

			if (this.select_invitees.length !== 0) {
				const obj_tmp = {};
				this.select_invitees.forEach(d => {
					if (!obj_tmp[d.employee.id]) {
						invitees_list.push(d);
						obj_tmp[d.employee.id] = true;
					}
				});
			}

			return invitees_list;
		},
		abledEdit() {
			let is_able = true;
			
			if (this.editEventItem) {
				if (this.editEventItem.pay_processed) {
					is_able = false;
				} else if (this.editEventItem.leave_approved) {
					if (!this.modifyPubHolPrivilege || !this.approveLeaveEventsPrivilege) {
						is_able = false;
					}
				} else {
					if (!this.modifyPubHolPrivilege) {
						is_able = false;
					}
				}
			} 
			
			return is_able;
		}
	},
	watch: {
		job_search(val) {
			val && (this.job_select ?  val !== this.job_select.display_name : true) && this.jobQuery(val);
		},
		address_search(val) {
			val && (this.address_select ?  val !== this.address_select.display_name : true) && this.addressQuery(val);
		},
		contact_search(val) {
			val && (this.contact_select ?  val !== this.contact_select.display_name : true) && this.contactQuery(val);
		},
		invitees_search(val) {
			val && this.inviteesQuery(val);
		}
	},
	methods: {
		initDescription() {
			this.description_loading = false;
		},
		async getUserTimezone() {
			const url = '/api/user/me/timezone';

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						this.user_timezone = data;
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		async getTimezone() {
			this.timezone_loading = true;

			const url = '/api/support/timezones';

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						const timezone_group = {};

						const data_filter = data.filter(d => {
							const time_zone_key = d.value.toUpperCase();
							return !time_zone_key.includes(config.time_zone_keys[0]) && !time_zone_key.includes(config.time_zone_keys[1]);
						});
						data_filter.forEach(timezone => {
							const group_key = (timezone.value.split('/'))[0];
							const group_key_arr = Object.keys(timezone_group);

							if (group_key_arr.includes(group_key)) {
								const arr = timezone_group[`${group_key}`];

								const child = {
									key: timezone.value,
									name: `${(timezone.description.split(' '))[0]} (GMT${(timezone.description.split(' '))[1]})`,
									is_default: timezone.is_default,
									children: 0
								}

								timezone_group[`${group_key}`] = [...arr, child];
							} else {
								const child = {
									key: timezone.value,
									name: `${(timezone.description.split(' '))[0]} (GMT${(timezone.description.split(' '))[1]})`,
									is_default: timezone.is_default,
									children: 0
								}
								timezone_group[`${group_key}`] = [child];
							}
						});

						let timezone_list = [];
						for (const [key, value] of Object.entries(timezone_group)) {
							const node = {
								key: `parent_${key}`,
								name: key,
								is_default: false,
								children: value.length
							}
							timezone_list= [...timezone_list, node, ...value];
						}
						this.timezone_items = timezone_list;

						if (!this.isEdit && !this.isDuplication) {
							const default_timezone_arr = timezone_list.filter(timezone => { return timezone.is_default === true});
							this.timezone = default_timezone_arr.length !== 0 ? default_timezone_arr[0] : null;
						}
					} else {
						this.error_msg = reason;
						this.timezone_loading = false;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
					this.timezone_loading = false;
				})
				.finally(() => {
					this.timezone_loading = false;
				})
		},
		async getEventTypes() {
			const url = '/api/config/eventtype';

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						const event_type_items_tmp = data.filter(d => { return d.plan_type === Plan_Type_Leave && d.leave_type === Leave_Type });
						this.event_type_items = event_type_items_tmp;
						if (event_type_items_tmp.length === 1 && !this.isEdit) {
							this.event_type_select = event_type_items_tmp[0];
							this.onSelected(event_type_items_tmp[0]);
						}
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		async getCurrentUser() {
			if (this.userAddressBook) {
				const name = this.formatName(this.userAddressBook.display_name);
				const description = name.length > DescriptionLimit
					? name.slice(0, DescriptionLimit) + '...'
					: name;

				const organiser_obj = {
					id: `${ALLEMPLOYEES}_${this.userAddressBook.id}`,
					name: description,
					type: ALLEMPLOYEES,
					accepted: Invited_Code,
					contact: null,
					freelancer: false,
					employee: {
						id: this.userAddressBook.id,
						contact_id: null,
						code: this.userAddressBook.code,
						display_name: description,
						email: this.userAddressBook.email,
						send_email: true
					},
					image: this.userAddressBook.image,
					uri: this.userAddressBook.uri
				};

				this.select_invitees.push(organiser_obj);

			} else {
				const url = '/api/user/me';
				
				axios
					.get(url, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					})
					.then((val) => {
						const { status, data, reason } = val.data;

						if (status == "OK") {
							const name = this.formatName(data.addressbook.display_name);
							const description = name.length > DescriptionLimit
								? name.slice(0, DescriptionLimit) + '...'
								: name;

							const organiser_obj = {
								id: `${ALLEMPLOYEES}_${data.addressbook.id}`,
								name: description,
								type: ALLEMPLOYEES,
								accepted: Invited_Code,
								contact: null,
								freelancer: false,
								employee: {
									id: data.addressbook.id,
									contact_id: null,
									code: data.addressbook.code,
									display_name: description,
									email: data.addressbook.email,
									send_email: true
								},
								image: data.addressbook.image,
								uri: data.addressbook.uri
							};							
				
							this.select_invitees.push(organiser_obj);
						} else {
							this.error_msg = reason;
						}
					})
					.catch((e) => {
						this.error_msg = e.message;
					});
			}
		},
		async getEvent(event) {
			this.loading = true;

			const url = `/api/events/${event.id}?iteration=${event.iteration}`;

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						this.loading = false;

						this.event_name = data.description;
						this.event_wholeday = data.all_day;

						const timezone_key = data.time_zone && data.time_zone.length !== 0 ? data.time_zone : this.user_timezone;
						this.timezone = (this.timezone_items.filter(timezone => { return timezone.key === timezone_key }))[0];

						const event_type = {
							id: data.event_type.id,
							desc: data.event_type.desc,
							plan_type: data.event_type.plan_type,
						};
						this.event_type_select = event_type;

						if (data.all_day) {
							this.start_date = moment(data.start_date).format('YYYY-MM-DD');
							this.end_date = moment(data.end_date).format('YYYY-MM-DD');

							this.event_start_date = moment(data.start_date).format('YYYY-MM-DD');
							this.event_end_date = moment(data.end_date).format('YYYY-MM-DD');

							this.origin_event_start_date = this.event_start_date;
							this.origin_event_end_date = this.event_end_date;

						} else {
							this.start_date = moment(data.start_date).format('YYYY-MM-DD');
							this.event_date = moment(data.start_date).format('YYYY-MM-DD');
							this.origin_event_date = this.event_date;

							this.event_start_time = moment(data.start_datetime, 'YYYYMMDD HH:mm').format('h:mm a');
							this.event_end_time = moment(data.end_datetime, 'YYYYMMDD HH:mm').format('h:mm a');

							this.time_start_init = this.event_start_time ? this.event_start_time : '';
							this.time_end_init = this.event_end_time ? this.event_end_time : '';
						
							this.origin_event_start_time = this.event_start_time;
							this.origin_event_end_time = this.event_end_time;

							const start_tmp = moment(data.start_date);
							const end_tmp = moment(data.end_date);
							const diff = end_tmp.diff(start_tmp, 'm');
							this.event_duration = diff === 0 ? Event_Duration_Default : diff;
						}

						this.links = data.event_type.links;
						this.is_contact_needed = data.event_type.contact_needed;

						if (data.job) {
							data.job['name'] = data.job.display_name;
							data.job['display_name'] = `${data.job.code} - ${data.job.name}`;
							this.job_select = data.job;
							this.job_items.push(this.job_select);
						}

						if (data.client) {
							const address_tmp = data.client;
							address_tmp['name'] = data.client.display_name;
							this.address_select = address_tmp;
							this.address_items.push(this.address_select);

							this.is_business = data.client.is_company;
						}

						if (data.contact) {
							this.contact_select = data.contact;
							this.contact_items.push(this.contact_select);
						}

						this.content = data.notes_fmt;
						this.can_invitemultiple = data.event_type.invite_multiple;

						const invitees_tmp = [];
						data.invitees.forEach(invite => {
							const name = this.formatName(invite.contact ? invite.contact.display_name : invite.employee.display_name);
							const description = name.length > DescriptionLimit
								? name.slice(0, DescriptionLimit) + '...'
								: name;
								
							let prefix_tag = ALLEMPLOYEES;
							if (invite.employee.is_feelancer && invite.employee.is_employee) {
								prefix_tag = ALLEMPLOYEES;
							} else if (invite.employee.is_feelancer === true) {
								prefix_tag = FREELANCER;
							}

							const invite_obj = {
								id: `${invite.contact ? CLIENT : prefix_tag}_${invite.contact ? invite.contact.id :invite.employee.id}`,
								name: description,
								type: invite.contact ? CLIENT : prefix_tag,
								accepted: invite.accepted,
								contact: null,
								freelancer: prefix_tag === FREELANCER ? true : false,
								employee: {
									id: invite.contact ? invite.contact.id: invite.employee.id,
									contact_id: invite.contact ? invite.contact.id : null,
									code: invite.contact ? '' : invite.employee.code,
									display_name: invite.contact ? invite.contact.display_name : invite.employee.display_name,
									email: invite.contact ?  invite.contact.email : invite.employee.email,
									send_email: false
								},
								image: `/api/addressbook/${invite.contact ? invite.contact.id :invite.employee.id}/image.png`,
								uri: `/api/addressbook/${invite.contact ? invite.contact.id :invite.employee.id}`
							};
							invitees_tmp.push(invite_obj);
						});

						this.existed_invitees = data.invitees.map(i => {
							let prefix_tag = ALLEMPLOYEES;
							if (i.employee.is_feelancer && i.employee.is_employee) {
								prefix_tag = ALLEMPLOYEES;
							} else if (i.employee.is_feelancer === true) {
								prefix_tag = FREELANCER;
							}
							return {id: `${i.contact ? CLIENT : prefix_tag}_${i.contact ? i.contact.id :i.employee.id}`, invite_id: i.id}
						});
						this.select_invitees = [...invitees_tmp];
						this.mark_approved = data.leave_approved;

					} else {
						this.error_msg = reason;
						this.loading = false;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
					this.loading = false;
				});
		},
		jobQuery(key) {
			this.job_loading = true;
			const params = [];
			params.push("code_and_name=" + encodeURIComponent(key));

			let url = "/api/jobs";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const {status, data, reason } = val.data;
					if (status == "OK") {
						const code_data = data.filter(d => { 
							const code_lowercase = d.code.toLowerCase();
							const key_lowercase = key.toLowerCase();
							return code_lowercase.includes(key_lowercase);
						});
						
						const desc_data = data.filter(d => { 
							const code_lowercase = d.code.toLowerCase();
							const key_lowercase = key.toLowerCase();
							return !code_lowercase.includes(key_lowercase);
						});

						const data_filter = [...code_data, ...desc_data];
						
						this.job_items = data_filter.map(d => {
							const description = d.display_name.length > DescriptionLimit
								? d.display_name.slice(0, DescriptionLimit) + '...'
								: d.display_name;
							
							let is_disabled = false;
							if (this.completedJobPrivilege) {
								is_disabled = this.job_invalid_status_ids.includes(d.status.id) ? true : false;
							}

							const obj = {
								id: d.id,
								display_name: description,
								acc_dir: d.acc_dir,
								acc_exec: d.acc_exec,
								job_type: d.job_type,
								currency_id: d.currency.id,
								currency: d.currency,
								disabled: is_disabled,
								client: d.client
							};

							return obj;
						});

					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.job_loading = false
				});
		},
		addressQuery(key) {
			this.address_loading = true;

			const params = [];
			params.push("name=" + encodeURIComponent(key));
			params.push("abook_types=" + Address_Types);

			let url = "/api/addressbook";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const json = val.data;

					if (typeof(json) == "string") {
						json = JSON.parse(json);
					}
					const { status, data } = json;

					if (status == "OK") {
						this.address_items = data.map(d => {
							const name = this.formatName(d.display_name);

							const description = name.length > DescriptionLimit
								? name.slice(0, DescriptionLimit) + '...'
								: name;

							d[`name`] = description;

							return d;
						});
					} 
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.address_loading = false
				});
		},
		contactQuery(key) {
			this.contact_loading = true;
			
			const params = [];
			params.push("name=" + encodeURIComponent(key));
			if (this.address_select) {
				params.push("abook_ids=" + this.address_select.id);
			}
			if (this.job_select) {
				params.push("job_ids=" + this.job_select.id);
			}

			let url = `/api/addressbook/contacts`;
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const json = val.data;

					if (typeof(json) == "string") {
						json = JSON.parse(json);
					}
					const { status, data } = json;

					if (status == "OK") {
						this.contact_items = data;

						if (this.contact_items.length === 1) {
							this.contact_select = this.contact_items[0];
						}
					} 
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.contact_loading = false;
				});
		},
		inviteesQuery(key) {
			this.invitees_loading = true;

			const params = [];
			params.push("name=" + encodeURIComponent(key));
			params.push("allow_all=" + true);
			params.push("find_employee=" + true);
			params.push("find_freelancer=" + true);

			let url = "/api/addressbook/email";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const json = val.data;

					if (typeof(json) == "string") {
						json = JSON.parse(json);
					}
					const { status, data } = json;

					if (status == "OK") {
						this.invitees_items = data.map(d => {
							const name = this.formatName(d.name);
							const description = name.length > DescriptionLimit
								? name.slice(0, DescriptionLimit) + '...'
								: name;

							const invite_obj = {
								id: 0,
								accepted: Invited_Code,
								contact: null,
								employee: {
									id:  d.contact_id ? d.contact_id : d.abook_id,
									contact_id: d.contact_id ? d.contact_id : null,
									code: d.code,
									display_name: description,
									email: d.email,
									send_email: true
								},
								image: `${d.uri}/image.png`,
								uri: d.uri
							};

							return invite_obj;
						});
					} 
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.invitees_loading = false
				});
		},
		onDeleteEvent() {
			this.delete_visible = true;
		},
		onDelete() {
			const url = `/api/events/${this.editEventItem.id}`;

			axios
				.delete(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(val => {
					const { status, reason} = val.data;

					if (status == "OK") {
						this.delete_visible = false;
						const title = this.editEventItem.description;

						this.notice_text.push(`Public holiday ‘(${title})’ has been deleted successfully.`);
						this.visible_notice = true;
						this.tid = setTimeout(this._close, 2000);
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				});
		},
		onEditEventClose() {
			this.$emit('close');
		},
		onNameChange() {
			this._checkErrorFlag('onNameChange');
		},
		onSelected(event_type) {
			this.type_loading = true;

			const url = `/api/config/eventtype/${event_type.id}`;

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						this.event_wholeday = data.is_wholeday;
						this.event_duration = this.event_duration = Number(data.duration) === 0 ? Event_Duration_Default : Number(data.duration);
						this.links = data.links;
						this.is_contact_needed = data.is_contact_needed;

						if (!data.is_wholeday && this.startTime.length !== 0) {
							this.event_end_time = moment(this.event_start_time, 'h:mm a').add(this.event_duration, 'm').format('h:mm a');
							this.time_end_init = this.event_end_time ? this.event_end_time : '';
						}
						if (data.is_wholeday && this.start_date.length !== 0) {
							this.event_start_date = this.start_date;
							this.event_end_date = this.end_date;
						}

						this.can_invitemultiple = data.can_invitemultiple;
						if (this.can_invitemultiple) {
							this.email = true;
						} else {
							this.email = false;
						}

						this.onAllEmailChange();
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.type_loading = false;
				});

			this._checkErrorFlag('onSelected');
		},
		onDateRangeChange(date_arr) {
			this.error_msg = '';

			if (date_arr.length === 0) {
				this.start_date = '';
				this.end_date = '';
			}

			if (date_arr.length === 2) {
				this.event_start_date = date_arr[0];
				this.event_end_date = date_arr[1];

				this.start_date = date_arr[0];
				this.end_date = date_arr[1];
			}

			if (this.isEdit) {
				this.criticalInfoChange(this.event_start_date, this.origin_event_start_date);
				this.criticalInfoChange(this.event_end_date, this.origin_event_end_date);
			}

			this._checkErrorFlag('onEndDateChange');
		},
		onDateChange(date) {
			this.event_date = date;

			if (this.isEdit) {
				this.criticalInfoChange(this.event_date, this.origin_event_date);
			}

			this.start_date = date;
			this.end_date = date;

			this._checkErrorFlag('onDateChange');
		},
		onTimeStartChange(time) {
			this.start_time_error = false;
			this.end_time_error = false;

			this.event_start_time = time;

			if (this.isEdit) {
				this.criticalInfoChange(this.event_start_time, this.origin_event_start_time);
			}

			this._time_error_check('start');
			this._checkErrorFlag('onStartTimeChange');
		},
		onTimeEndChange(time) {
			this.start_time_error = false;
			this.end_time_error = false;

			this.event_end_time = time;

			if (this.isEdit) {
				this.criticalInfoChange(this.event_end_time, this.origin_event_end_time);
			}

			this._time_error_check('end');
			this._checkErrorFlag('onEndTimeChange');
		},
		_time_error_check(type) {
			const time_start = this.event_start_time ? this.event_start_time: '0';
			let time_start_tmp = time_start.replace(/\s+/g,"");

			const time_end = this.event_end_time ? this.event_end_time : '0';
			let time_end_tmp = time_end.replace(/\s+/g,"");

			if (validTime(time_start_tmp) && validTime(time_end_tmp)) {
				const time1 = moment(time_start_tmp, 'HH:mma');
				const time2 = moment(time_end_tmp, 'HH:mma');
				const budget = time2.diff(time1, 'minutes');

				if (budget < 0) {
					if (type === 'start') {
						this.start_time_error = true;
					}

					if (type === 'end') {
						this.end_time_error = true;
					}
				} 
			}
		},
		onTimezoneChange() {
			this._checkErrorFlag('all');
		},
		onJobSelected(job) {
			this._checkErrorFlag('onJobSelected');
			this.contact_select = null;
			this.contact_items = [];

			if (job) {
				const ad_obj = {
					id: job.client.id,
					display_name: job.client.name,
					code: job.client.code,
					is_company: job.client.is_company
				};

				this.address_items.push(ad_obj);
				this.address_select = ad_obj;
				this.is_business = job.client.is_company;
			}	
		},
		onAddressSelected(adddress) {
			this._checkErrorFlag('onAddressSelected');
			this.onEmailChange();

			if (adddress === null) {
				this.is_business = true;
				this.contact_select = null;
				this.contact_items = [];
			}

			if (adddress !== null) {
				this.is_business = adddress.is_company;
				this.contact_select = null;
				this.contact_items = [];
			}
		},
		onContactSelected() {
			this._checkErrorFlag('onJobSelected');
		},
		onRemoveAddress() {
			this.address_select = null;
			this._checkErrorFlag('onAddressSelected');
		},
		onInviteeSelected(invitees) {
			this.select_invitees = invitees;
			
			this.onEmailChange();

			this._checkErrorFlag('all');
		},
		clearInviteesItems() {
			this.invitees_items = [];
		},
		onMarkCompleteChange() {
			this._checkErrorFlag('all');
		},
		onSelectAllEmailChange() {
			this.onAllEmailChange();
			this._checkErrorFlag('all');
		},
		onAllEmailChange() {
			if (this.email) {
				this.select_invitees.forEach(invite => {
					invite.employee.send_email = true;
				});
			} else {
				this.select_invitees.forEach(invite => {
					invite.employee.send_email = false;
				});
			}
		},
		onEmailChange() {
			this._checkErrorFlag('all');
			const invitees_list = [...this.select_invitees];
			const is_all_selected = invitees_list.length === 0  ? false : invitees_list.every(invite => { return invite.employee.send_email === true });

			if (is_all_selected) {
				this.email = true;
			} else {
				this.email = false;
			}
		},
		onRemoveInvitee(id) {
			const e_id = Number((id.split('_'))[1]);
			this.select_invitees = this.select_invitees.filter(invitee => { return invitee.employee.id !== e_id });
			
			if (this.select_invitees.length === 0) {
				this.email = false;
			}
			this._checkErrorFlag('all');
		},
		onRepeatModeComfirm(mode) {
			const repeat_mode_obj = {
				iteration: this.editEventItem.iteration,
				repeat_mode: mode
			};
			const params = this.getParams(repeat_mode_obj);
			this._updateEvent(this.editEventItem.id, params);
			
			this.recurring_comfirm_visible = false;
		},
		async onSave() {
			if (this.button_click_flag) return;

			this.button_click_flag = true;

			this._checkErrorFlag('all');

			if (this.isEdit) {
				const params = this.getParams();
				this._updateEvent(this.editEventItem.id, params);
			} else {
				const params = this.getParams();
				this._creaetEvent(params);
			}
		},
		formatName(name) {
			let display_name = '';

			if (name && name.includes(',')) {
				const name_arr = name.split(',');
				if (name_arr[1].includes('(')) {
					const name_tmp = name_arr[1];
					const index = name_tmp.indexOf('(');
					const first_name = name_tmp.substring(0, index-1).trim();
					const last_name = name_arr[0].trim();
					display_name = `${first_name} ${last_name} ${name_tmp.substring(index, name_tmp.length)}`;
				} else {
					const first_name = name_arr[1].trim();
					const last_name = name_arr[0].trim();
					display_name = `${first_name} ${last_name}`;
				}
			} else {
				display_name = name;
			}

			return display_name;
		},
		criticalInfoChange(new_value, old_value) {
			if (new_value !== old_value && this.can_invitemultiple) {
				this.email = true;
				this.select_invitees.forEach(invite => {
					invite.employee.send_email = true;
				});
			}
		},
		getParams(repeat_mode_obj) {
			const params = {};

			params['event_type_id'] = this.event_type_select.id;
			params['description'] = this.event_name;
			params['timezone'] = this.timezone.key;
			params['all_day'] = this.event_wholeday;

			/** timezone conversion */
			const start_date_tmp = this.event_wholeday ?
				moment(`${this.event_start_date} 00:00:00`, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
				: moment(`${this.event_date} ${this.event_start_time}`, 'YYYY-MM-DD hh:mm a').format('YYYY-MM-DD HH:mm:ss');
			
			const end_date_tmp = this.event_wholeday ?
				moment(`${this.event_end_date} 23:59:59`, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
				: moment(`${this.event_date} ${this.event_end_time}`, 'YYYY-MM-DD hh:mm a').format('YYYY-MM-DD HH:mm:ss');

			moment.tz.setDefault(this.timezone.key);
			const timezone_start_date = moment(start_date_tmp, 'YYYY-MM-DD HH:mm:ss').tz(this.user_timezone).format();
			const timezone_end_date = moment(end_date_tmp, 'YYYY-MM-DD HH:mm:ss').tz(this.user_timezone).format();
			moment.tz.setDefault(this.user_timezone);

			const start_date = moment(timezone_start_date).utc().format('YYYY-MM-DD HH:mm:ss Z');
			const end_date = moment(timezone_end_date).utc().format('YYYY-MM-DD HH:mm:ss Z');

			params['start_date'] = start_date;
			params['end_date'] = end_date;

			if (!this.event_wholeday) {
				const start_time = moment(this.event_start_time, 'hh:mm a');
				const end_time = moment(this.event_end_time, 'hh:mm a');
				const duration = end_time.diff(start_time, 'minutes');
				params['duration'] = duration;
			}
			if (this.links === Mandatory || this.links === Mandatory_Job || this.address_select) {
				params['abook_id'] = this.address_select.id;
			}
			if (this.links === Mandatory_Job || this.job_select) {
				params['job_id'] = this.job_select.id;
			}
			if (this.is_contact_needed && this.contact_select) {
				params['contact_id'] = this.contact_select.id;
			}
			params['employee_id'] = this.userAddressBook.id;
			params['plan_type'] = this.event_type_select.plan_type;
			params['repeat_unit'] = 0;
			
			params['notes'] = this.content.length !== 0 ? this.htmlToPlain(this.content) : '';
			params['notes_fmt'] = this.content;

			if (this.select_invitees.length === 0) {
				params['invitees'] = [];				
			} else {
				const invitee_list = [];
				
				const unique = [];
				const obj_tmp = {};
				this.select_invitees.forEach(d => {
					if (!obj_tmp[d.employee.id]) {
						unique.push(d);
						obj_tmp[d.employee.id] = true;
					}
				});

				unique.forEach(invitee => {
					const id_arr = this.existed_invitees.filter(i => { return i.id === invitee.id})
					const invite_id = id_arr.length !== 0 ? id_arr[0].invite_id : 0;

					const invitee_obj = {
						id: invite_id,
						accepted: invitee.accepted,
						is_deleted: false,
						pay_processed: false,
						send_email: invitee.employee.send_email,
						email_id: invitee.employee.email,
						is_organiser: false
					}

					if (invitee.employee.contact_id) {
						invitee_obj['contact_id'] = invitee.employee.contact_id;
					} else {
						invitee_obj['employee_id'] = invitee.employee.id;
					}

					invitee_list.push(invitee_obj);
				});

				params['invitees'] = invitee_list;
			}

			if (repeat_mode_obj) {
				params['iteration'] = repeat_mode_obj.iteration;
				params['repeat_mode'] = repeat_mode_obj.repeat_mode;
			}

			if (this.approveLeaveEventsPrivilege && this.mark_approved) {
				params['is_approved'] = this.mark_approved;
				params['approved_by'] = this.userId;
			}

			return params;			
		},
		_creaetEvent(params) {
			const url = '/api/events';

			axios
				.post(url, params, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const json = val.data;

					const { status, reason } = json;

					if (status == "OK") {
						this.notice_text.push('Public holiday has been created successfully');
						this.visible_notice = true;
						this.tid = setTimeout(this._close, 2000);
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.button_click_flag = false;
				});
		},
		_updateEvent(id, params) {
			const url = `/api/events/${id}`;

			axios
				.put(url, params, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const json = val.data;

					const { status, reason } = json;

					if (status == "OK") {
						this.notice_text.push('Public holiday has been updated successfully');
						this.visible_notice = true;
						this.tid = setTimeout(this._close, 2000);
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.button_click_flag = false;
				});
		},
		_checkErrorFlag(key) {
			this.error_name_flag = false;
			this.error_type_flag = false;
			this.error_start_date_flag = false;
			this.error_end_date_flag = false;
			this.error_date_flag = false;
			this.error_start_time_flag = false;
			this.error_end_time_flag = false;
			this.error_job_flag = false;
			this.error_addressbook_flag = false;

			if (key === 'onNameChange' ) {
				if (this.event_name.length === 0) {
					this.error_name_flag = true;
				}
			}

			if (key === 'onSelected') {
				if (this.event_type_items.length > 1) {
					if (this.event_name.length === 0) {
						this.error_name_flag = true;
					}
					if (!this.event_type_select) {
						this.error_type_flag = true;
					}
				} else {
					if (!this.event_type_select) {
						this.error_type_flag = true;
					}
				}
			}

			if (key === 'onStartDateChange') {
				if (this.event_name.length === 0) {
					this.error_name_flag = true;
				}
				if (!this.event_type_select) {
					this.error_type_flag = true;
				}
				if (this.event_wholeday) {
					if (!this.event_start_date) {
						this.error_start_date_flag = true;
					}
				}
			}

			if (key === 'onEndDateChange') {
				if (this.event_name.length === 0) {
					this.error_name_flag = true;
				}
				if (!this.event_type_select) {
					this.error_type_flag = true;
				}
				if (this.event_wholeday) {
					if (!this.event_start_date) {
						this.error_start_date_flag = true;
					}
					if (!this.event_end_date) {
						this.error_end_date_flag = true;
					}
				}
			}

			if (key === 'onDateChange') {
				if (this.event_name.length === 0) {
					this.error_name_flag = true;
				}
				if (!this.event_type_select) {
					this.error_type_flag = true;
				}
				if (!this.event_wholeday) {
					if (!this.event_date) {
						this.error_date_flag = true;
					}
				}
			}

			if (key === 'onStartTimeChange') {
				if (this.event_name.length === 0) {
					this.error_name_flag = true;
				}
				if (!this.event_type_select) {
					this.error_type_flag = true;
				}
				if (!this.event_wholeday) {
					if (!this.event_date) {
						this.error_date_flag = true;
					}
					if (!this.event_start_time) {
						this.error_start_time_flag = true;
					}
				}
			}

			if (key === 'onEndTimeChange') {
				if (this.event_name.length === 0) {
					this.error_name_flag = true;
				}
				if (!this.event_type_select) {
					this.error_type_flag = true;
				}
				if (!this.event_wholeday) {
					if (!this.event_date) {
						this.error_date_flag = true;
					}
					if (!this.event_start_time) {
						this.error_start_time_flag = true;
					}
					if (!this.event_end_time) {
						this.error_end_time_flag = true;
					}
				}
			}

			if (key === 'onJobSelected') {
				if (this.event_name.length === 0) {
					this.error_name_flag = true;
				}
				if (!this.event_type_select) {
					this.error_type_flag = true;
				}

				if (this.event_wholeday) {
					if (!this.event_start_date) {
						this.error_start_date_flag = true;
					}
					if (!this.event_end_date) {
						this.error_end_date_flag = true;
					}
					
				} else {
					if (!this.event_date) {
						this.error_date_flag = true;
					}
					if (!this.event_start_time) {
						this.error_start_time_flag = true;
					}
					if (!this.event_end_time) {
						this.error_end_time_flag = true;
					}
				}

				if (this.links === Mandatory_Job && !this.job_select) {
					this.error_job_flag = true;
				}
			}

			if (key === 'onAddressSelected') {
				if (this.event_name.length === 0) {
					this.error_name_flag = true;
				}
				if (!this.event_type_select) {
					this.error_type_flag = true;
				}

				if (this.event_wholeday) {
					if (!this.event_start_date) {
						this.error_start_date_flag = true;
					}
					if (!this.event_end_date) {
						this.error_end_date_flag = true;
					}
					
				} else {
					if (!this.event_date) {
						this.error_date_flag = true;
					}
					if (!this.event_start_time) {
						this.error_start_time_flag = true;
					}
					if (!this.event_end_time) {
						this.error_end_time_flag = true;
					}
				}

				if (this.links === Mandatory_Job && !this.job_select) {
					this.error_job_flag = true;
				}

				if ((this.links === Mandatory_Job || this.links === Mandatory) && !this.address_select) {
					this.error_addressbook_flag = true;
				}
			}

			if (key === 'all') {
				if (this.event_name.length === 0) {
					this.error_name_flag = true;
				}
				if (!this.event_type_select) {
					this.error_type_flag = true;
				}
				if (this.event_wholeday) {
					if (!this.event_start_date) {
						this.error_start_date_flag = true;
					}
					if (!this.event_end_date) {
						this.error_end_date_flag = true;
					}
					
				} else {
					if (!this.event_date) {
						this.error_date_flag = true;
					}
					if (!this.event_start_time) {
						this.error_start_time_flag = true;
					}
					if (!this.event_end_time) {
						this.error_end_time_flag = true;
					}
				}
				if (this.links === Mandatory_Job && !this.job_select) {
					this.error_job_flag = true;
				}
				if ((this.links === Mandatory_Job || this.links === Mandatory) && !this.address_select) {
					this.error_addressbook_flag = true;
				}
			}
		},
		_close() {
			this.visible_notice = false;
			this.notice_text = [];
			this.$emit('close');
		},
		htmlToPlain(html_str) {
			const dom_tmp = document.createElement('div');
			dom_tmp.innerHTML = html_str;
			return dom_tmp.textContent || dom_tmp.innerText || '';
		}
	}
}
</script>

<style lang="scss" scoped>
.create-task-container {
  background: #FFFFFF;
  border-radius: 4px;
  max-width: 100%;
}
.column-container {
	display: flex;
	flex-flow: column nowrap;
	align-content: flex-start;
}
.row-container {
	display: flex;
	flex-flow: row nowrap;
	justify-content: space-between;
}
.top-line {
  width: 100%;
  height: 4px;
  background: #FFB946;
  border-radius: 4px 4px 0px 0px;
}
.task-top {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
  align-items: center;
}
.title-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #C18014;
}
.task-title {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}
.item-text {
	font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #37495F;
	opacity: 0.87;
}
.item-text-disable {
	font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #37495F;
	opacity: 0.5;
}
.step-item-text-hover {
	&:hover {
		cursor: pointer;
	}
}
.over-text {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.over-background {
	&:hover {
		background-color: #FAFAFA;
		border-radius: 4px;
	}
}

.optional-text {
	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 12px;
	line-height: 20px;

	text-align: right;
	letter-spacing: 0.4px;
	color: #37495F;
}
.optional-text-red {
	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 12px;
	color: #F45252;
}
</style>